import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import QuestionLabel from './QuestionLabel';
import { FormPart, part } from '~/lib/FormCssApi';
import { format } from 'date-fns';
import { dateStringToDateTime, formatInternalDate } from '~/lib/DateTime';
import {
    DATE_QUESTION_FORMAT,
    parseDateAnswer,
} from '~/lib/Questions/Questions.utils';

const DateQuestion = forwardRef(({ label, value, setValue, settings }, ref) => {
    const inputRef = useRef(null);
    const parsedValue = parseDateAnswer(value);
    const inputValue = parsedValue ? formatInternalDate(parsedValue) : '';

    function onChange(newInputValue) {
        if (newInputValue) {
            const newValue = format(
                dateStringToDateTime(newInputValue),
                DATE_QUESTION_FORMAT,
            );
            setValue(newValue);
        } else {
            setValue('');
        }
    }

    useImperativeHandle(ref, () => ({
        // A partially entered date (ex. a month and day with no year) reports an
        //  empty value, so validation can't see the problem from the answer and
        //  has to ask the input itself
        hasBadInput: () => !!inputRef.current?.validity?.badInput,
    }));

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                <input
                    {...part(FormPart.INPUT)}
                    ref={inputRef}
                    type="date"
                    value={inputValue}
                    onChange={e => onChange(e.target.value)}
                />
            </div>
        </label>
    );
});

DateQuestion.displayName = 'DateQuestion';

export default DateQuestion;
